module.exports = __webpack_public_path__ + "img/id.743f4e1f.png";